<!-- eslint-disable -->
<template>
  <div class="container">
    <div class="row terms-box">
      <div class="col-lg-12">
        <center>
          <h1>共有ポリシー</h1>
        </center>
        <div class="date">2021年9月14日 初版</div>
        <div>
          <p>
            １　Nola共有機能の目的は、第三者からのアドバイスや批評を通して各作品の推敲に寄与することです。そのため本機能では作品や作者に対して自由にコメントすることができますが、コメントは上記目的に沿った適切な表現で行い、誹謗中傷等本機能の目的を阻害するような不適切な表現をしないよう注意してください。
          </p>
          <br />
          <p>
            ２　本機能では、共同執筆やゲームシナリオの制作などチームで制作をされる方向けに、同じ共有リンクのURLを受け取った全ての人がお互いのコメントを閲覧することができるように開発しております。<br />
            各個人と個別にコメントをやり取りしたい場合や、コメントを複数人で共有したくない場合は、共有する一人一人に別々の共有リンクを発行して渡すようにしてください。
          </p>
          <br />
          <p>３　共有された作品の盗作は厳に慎んでください。</p>
          <br />
          <p>
            ４　共有するために作成されるリンクは、リンクを共有されたNola会員であれば誰でもアクセス可能です。そのため、例えば、作品を共有したNola会員がSNS等でリンクを掲載した場合、共有を意図していないNola会員に作品を閲覧される可能性がありますので、作品を共有する第三者の選択には十分注意してください。（なお、この場合Nola会員でなければ閲覧できませんが、新規で会員登録をすると閲覧可能になりますので、SNS等に共有してしまうと潜在的にはNola会員以外の第三者に閲覧される可能性があります。）<br />
            なお、万が一、発行した共有リンクを共有を希望する人以外へ送ってしまった（送られてしまった）場合は、「共有リンク一覧」から任意の共有リンクを選択して画面下の【共有リンクを停止する】を押下することで、共有リンクの利用を停止することができますのでご対応をお願いいたします。
          </p>
          <br />
          <p>
            ５　作品を共有されたNola会員は、当該作品の作者の許可なくSNSやメール等の通信手段で拡散することは一切禁止しております。作品をより多くの方に知ってもらいたいという動機であっても拡散する際は作者の許可を必ず取ってください。
          </p>
          <br />
          <p>
            ６　本機能の利用に関して、上記の注意事項並びに社会一般的なルールを遵守しなかったことにより、第三者（Nola会員であるか否かは問いません）との間でトラブル・紛争が発生した場合は、全て自己の責任でもって対処してください。当社は当該トラブル・紛争について一切の責任を負いません。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.terms-box {
  background-color: var(--color-surface-subtle);
  padding: 100px 13% 50px 13%;
  border: solid 10px var(--color-border);
}
.terms-box h1 {
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-bold);
  margin-top: 0px;
  margin-bottom: 30px;
  color: var(--color-text-normal);
  text-align: center;
  position: relative;
  display: inline-block;
  padding: 0 55px;
}
.terms-box h1:before,
.terms-box h1:after {
  content: "";
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 45px;
  height: 1px;
  background-color: var(--color-text-normal);
}
.terms-box h1:before {
  left: 0;
}
.terms-box h1:after {
  right: 0;
}

.terms-box h2 {
  font-size: var(--font-size-xl);
  margin-top: 30px;
  margin-bottom: 20px;
  color: var(--color-text-normal);
  border-bottom: solid 1px var(--color-border);
}
.terms-box p {
  color: var(--color-text-normal);
}
.date {
  text-align: right;
  font-size: var(--font-size-xs);
  color: var(--color-text-low);
}

/*スマホ画面でサイドメニューを非表示*/
@media screen and (max-width: 576px) {
  /* 表示領域が576px以下の場合に適用するスタイル */
  .terms-box {
    padding: 50px 15px;
  }
  .terms-box h1 {
    font-size: var(--font-size-xl);
    margin-bottom: 20px;
  }
  .terms-box h2 {
    font-size: var(--font-size-md);
    margin-top: 30px;
    margin-bottom: 15px;
  }
  .terms-box p {
    font-size: var(--font-size-sm);
  }
}
</style>
